import React, { useEffect, useState } from "react";
import axios from "axios";
import { HelpCircle } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

export default function Faq() {
  const [faqs, setFaqs] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/faq`)
      .then((r) => setFaqs(r.data || []))
      .catch(() => setFaqs([]));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
      <div className="text-center mb-12">
        <div className="w-12 h-12 rounded-2xl bg-blue-600 grid place-items-center mx-auto mb-4 text-white">
          <HelpCircle size={22} />
        </div>
        <div className="text-xs uppercase tracking-widest text-blue-600 font-semibold mb-3">FAQ</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">Frequently Asked Questions</h1>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          Everything you need to know about Simple Invoice. Can't find your answer? <a href="/contact" className="text-blue-600 hover:underline">Contact us</a>.
        </p>
      </div>

      {faqs === null && <div className="text-center text-sm text-muted-foreground" data-testid="faq-loading">Loading…</div>}

      {faqs && faqs.length === 0 && (
        <div className="text-center text-sm text-muted-foreground" data-testid="faq-empty">No FAQs published yet.</div>
      )}

      {faqs && faqs.length > 0 && (
        <div className="rounded-2xl bg-card border border-border px-6" data-testid="faq-list">
          <Accordion type="single" collapsible>
            {faqs.map((f) => (
              <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${f.id}`}>
                <AccordionTrigger className="font-heading font-semibold text-base">{f.question}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      )}
    </div>
  );
}
